export default __webpack_public_path__ + "static/mob-banner-b68c3639adfc3d82209612b728607adf.png";